import React, { useEffect, useState } from 'react';
import axios from 'axios';
import env from '../../../config/env';
import { useNavigate } from 'react-router-dom';
import bgImage from '../../../assets/images/whisperbi_fondo_login.jpg';
import InputForm from '../../../components/form/InputForm';
import ErrorAlert from '../../../components/common/alerts/ErrorAlert';
import Loader from '../../../components/common/loaders/Loader';

const ConfirmUser = () => {
  const navigate = useNavigate();

  const url = env.APP_URL;
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);

  const params = { email, code };

  const handleSubmit = async () => {
    setLoading(true);
    const verifyUrl = `${url}/verify`;
    try {
      const response = await axios.post(verifyUrl, params);
      setError('');
      setStep(2);
      return response.data;
    } catch (err) {
      setError(
        err?.response?.data?.error?.message ??
        err?.message ??
        'No se pudo confirmar el correo.'
      );
    } finally {
      setLoading(false);
    }
  };

  // Barra de progreso y navegación
  useEffect(() => {
    if (step === 2) {
      const intervalId = setInterval(() => setProgress((p) => p + 1), 40);
      if (progress === 100) navigate('/password/change-password');
      return () => clearInterval(intervalId);
    }
  }, [step, progress, navigate]);

  if (loading) return <Loader />;

  return (
    <div className="flex h-screen bg-black text-white">
      {/* Columna izquierda (form) */}
      <section className="w-full lg:w-1/2 h-full mx-auto">
        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
          <div className="w-full rounded-2xl border border-orange-500/60 bg-zinc-900/70 backdrop-blur shadow-xl md:mt-0 sm:max-w-md xl:p-0">
            <div className="p-6 sm:p-8 space-y-6">

              {step === 1 && (
                <div className="space-y-8">
                  <div className="flex mb-2">
                    <div className="w-full flex justify-center text-center">
                      <h1 className="text-2xl md:text-3xl font-bold">
                        Confirma tu correo electrónico
                      </h1>
                    </div>
                  </div>
                  <span className="block mx-auto h-1 w-16 bg-orange-500 rounded"></span>

                  <div className="space-y-4">
                    <p className="text-xs text-gray-300">
                      Ingresa tu correo electrónico y el código de confirmación que te
                      enviamos al momento de crear tu cuenta. Si no lo encuentras, revisa
                      spam o solicita un nuevo código.
                    </p>
                    <hr className="border-zinc-700" />

                    <InputForm
                      name="email"
                      placeholder="john_doe@example.com"
                      type="email"
                      title="Correo electrónico"
                      value={email}
                      setValue={setEmail}
                    />

                    <InputForm
                      name="code"
                      placeholder="Ingresa el código"
                      type="text"
                      title="Código"
                      value={code}
                      setValue={setCode}
                    />

                    {error && <ErrorAlert error={error} />}

                    <div>
                      <button
                        onClick={handleSubmit}
                        disabled={email.trim().length < 3 || code.trim().length < 3}
                        className="w-full py-3 font-semibold rounded-full bg-black text-white border-2 border-orange-500 enabled:hover:bg-black/90 enabled:hover:border-orange-400 enabled:cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-orange-500 transition"
                      >
                        Enviar
                      </button>
                    </div>
                    <hr className="border-zinc-700" />
                  </div>
                </div>
              )}

              {step === 2 && (
                <div className="text-center py-5 animate__animated animate__fadeIn">
                  <span className="text-2xl font-extrabold">¡Confirmación Exitosa!</span>
                  <div className="flex justify-center my-5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-28 h-28 fill-orange-500 animate__animated animate__flip"
                    >
                      <path
                        fillRule="evenodd"
                        d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <p className="text-sm mb-7 text-gray-300">
                    Tu correo electrónico ha sido confirmado exitosamente
                  </p>

                  {/* Barra de progreso */}
                  <div className="h-3 w-full mb-2 bg-zinc-800 rounded-md overflow-hidden">
                    <div
                      className="h-full bg-orange-500"
                      style={{ width: `${progress}%` }}
                    ></div>
                  </div>
                  <p className="text-xs text-gray-400">
                    En breve serás redirigido a la pantalla de restablecimiento de contraseña.
                  </p>
                </div>
              )}

            </div>
          </div>
        </div>
      </section>

      {/* Columna derecha (imagen) */}
      <section
        className="relative bg-cover bg-center bg-no-repeat w-1/2 h-full hidden lg:block"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="absolute inset-0 bg-black/50" />
      </section>
    </div>
  );
};

export default ConfirmUser;
